<template>
  <section class="offers">
    <Card
      v-for="product in products"
      :key="product.id"
      class="offers__card"
      :product="product"
    />
  </section>
</template>
<script>
import Card from './Card.vue';

export default {
  components: {
    Card,
  },
  data() {
    return {};
  },
  computed: {
    products() {
      return this.$store.state.config.medals.products;
    },
  },
  mounted() {
  },
  methods: {
  },
};
</script>

<style lang="stylus" scoped>
.offers {
  +desktop() {
    display: flex;
    flex-direction: row;
    gap: 30px;
  }
}

.offers__card {
  margin-bottom: 50px;

  +desktop() {
    flex: 1;
    margin: 0;
  }
}
</style>
